// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal input[data-v-28a45480]{position:sticky;top:0}", "",{"version":3,"sources":["webpack://./resources/js/components/modals/UserAddModal.vue"],"names":[],"mappings":"AAEE,8BACE,eAAA,CACA,KADJ","sourcesContent":["\n.modal {\n  input {\n    position: sticky;\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
